export const LOGIN_USER = 'LOGIN_USER';

export const PARENT_LOGIN_USER = 'PARENT_LOGIN_USER';

export const LOGOUT_USER = 'LOGOUT_USER';

export const MENU_ITEMS = 'MENU_ITEMS';
